/**
 * Filtro base fixo de toda segmentação: método de disparo = push. Quem aplica
 * é a legacy-api (segmentationQueryBuilder) — contagem, amostra, público salvo
 * e a IA já veem só lead com push disponível. O campo some do seletor pra não
 * virar condição redundante (ou que zera o público).
 */
export const PUSH_BASE_FIELD = 'hasPushToken';
